import { Dialog } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import { useIsBreakpointDown } from '~/modules/common/hooks';
import {
  TaskAssignmentDialogTitle,
  TaskAssignmentDialogContent,
  TaskAssignmentDialogFooter
} from '~/modules/tasks/components/TaskAssignmentDialog';
import { useTaskAssignmentDialogContentState } from '~/modules/tasks/components/TaskAssignmentDialog/hooks';

const dialogTitleId = 'task-assignment-dialog-title';

export const TaskAssignmentDialog = ({
  permittedActionUris,
  projectId,
  resource,
  onClose,
  open,
  refetchQueriesOnRemoveTaskAssignment
}) => {
  const isMobile = useIsBreakpointDown('sm');
  const [isAssignmentDirty, setIsAssignmentDirty] = useState(false);
  const [
    isResourceAllocationRowToBeRemoved,
    setIsResourceAllocationRowToBeRemoved
  ] = useState(false);

  const onTaskAssignmentUpdateSuccess = useCallback(
    ({ isResourceAllocationDeleted }) => {
      setIsAssignmentDirty(true);
      if (isResourceAllocationDeleted)
        setIsResourceAllocationRowToBeRemoved(true);
    },
    [setIsAssignmentDirty, setIsResourceAllocationRowToBeRemoved]
  );

  const onDialogClose = useCallback(
    () =>
      onClose({
        isAssignmentDirty,
        isResourceAllocationDeleted: isResourceAllocationRowToBeRemoved
      }),
    [onClose, isAssignmentDirty, isResourceAllocationRowToBeRemoved]
  );

  const [activeRequests, setActiveRequests] = useState(0);

  const {
    taskAssignmentDialogContentKey,
    searchCriteria,
    setSearchCriteria: setTaskAssignmentDialogContentSearchCriteria,
    resetTaskAssignments
  } = useTaskAssignmentDialogContentState();

  return (
    <Dialog
      disableBackdropClick
      disableEscapeKeyDown
      fullWidth
      maxWidth="sm"
      fullScreen={isMobile}
      open={open}
      onClose={onDialogClose}
      aria-labelledby={dialogTitleId}
    >
      <TaskAssignmentDialogTitle
        resource={resource}
        dialogTitleId={dialogTitleId}
      />
      <TaskAssignmentDialogContent
        key={taskAssignmentDialogContentKey}
        resource={resource}
        projectId={projectId}
        permittedActionUris={permittedActionUris}
        onTaskAssignmentUpdateSuccess={onTaskAssignmentUpdateSuccess}
        setActiveRequests={setActiveRequests}
        refetchQueriesOnRemoveTaskAssignment={
          refetchQueriesOnRemoveTaskAssignment
        }
        searchCriteria={searchCriteria}
        setSearchCriteria={setTaskAssignmentDialogContentSearchCriteria}
        resetTaskAssignments={resetTaskAssignments}
      />
      <TaskAssignmentDialogFooter
        onClose={onDialogClose}
        disabled={activeRequests > 0}
      />
    </Dialog>
  );
};

TaskAssignmentDialog.propTypes = {
  permittedActionUris: PropTypes.array,
  projectId: PropTypes.string,
  resource: PropTypes.object,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  refetchQueriesOnRemoveTaskAssignment: PropTypes.array
};
